export var ProjectFeatureName;
(function (ProjectFeatureName) {
    ProjectFeatureName["Accessibility"] = "accessibility";
    ProjectFeatureName["Act"] = "act";
    ProjectFeatureName["AutoInsight"] = "autoInsight";
    ProjectFeatureName["BotTraffic"] = "botTraffic";
    ProjectFeatureName["Cookieless"] = "cookieless";
    ProjectFeatureName["CovidWorkspace"] = "covidWS";
    ProjectFeatureName["CSInApp"] = "csInApp";
    ProjectFeatureName["Dareboost"] = "dareboost";
    ProjectFeatureName["DataExport"] = "dataExport";
    ProjectFeatureName["DecryptionPersistency"] = "decryptionPersistency";
    ProjectFeatureName["EMerch"] = "emerch";
    ProjectFeatureName["Exemption"] = "exemption";
    ProjectFeatureName["Heatmap"] = "heatmap";
    ProjectFeatureName["Impact"] = "impact";
    ProjectFeatureName["JSErrors"] = "jserrors";
    ProjectFeatureName["LegalHold"] = "legalHold";
    ProjectFeatureName["Mapping"] = "mapping";
    ProjectFeatureName["OpenApi"] = "api";
    ProjectFeatureName["ReferenceMapping"] = "referenceMapping";
    ProjectFeatureName["SamePageView"] = "samePageView";
    ProjectFeatureName["SearchForText"] = "searchForText";
    ProjectFeatureName["Segments"] = "segments";
    ProjectFeatureName["SessionReplay"] = "sessionReplay";
    ProjectFeatureName["SessionReplayV2"] = "sessionReplayV2";
    ProjectFeatureName["SpeedAnalysisRum"] = "speedAnalysisRum";
    ProjectFeatureName["TrackAnalysisContextUsage"] = "trackAnalysisContextUsage";
    ProjectFeatureName["TriggerSessionReplay"] = "triggerSessionReplay";
    ProjectFeatureName["UseHttp"] = "useHttp";
    ProjectFeatureName["WorkspaceNRT"] = "workspaceNRT";
    ProjectFeatureName["XStudio"] = "xstudio";
    ProjectFeatureName["Zonings"] = "zonings";
})(ProjectFeatureName || (ProjectFeatureName = {}));
//# sourceMappingURL=project.flags.js.map